/**slice Strings */
var sliceConstants = {
  SUCCEEDED: "succeeded",
  FAILED: "failed",
  IDLE: "idle",
  LOADING: "loading",
};
export default sliceConstants;
